import React from 'react';

const RoundLogo = ({ loader, className, background }) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 313.38 251.85"
      className={className}
   >
      <defs>
         <style>{`
            .svg-round-clip-1 {clip-path: url(#clip-path);}
            .svg-round-clip-2 {clip-path: url(#clip-path-2);
         `}</style>
         <clipPath id="clip-path">
            <polygon
               className="svg-color-1"
               points="224.22 191.26 224.73 170.49 253.8 170.49 254.31 191.26 224.22 191.26"
            />
         </clipPath>
         <clipPath id="clip-path-2">
            <path
               className="svg-color-1"
               d="M124.66,57.05c3.85-1.62,8.66,1.08,10.74,6h0a7.09,7.09,0,0,1,5.1-.42,7.2,7.2,0,0,1,4.07-6c3.85-1.62,8.66,1.08,10.74,6S156,73,152.12,74.58s-8.66-1.08-10.74-6a12.34,12.34,0,0,1-.74-2.41,3.66,3.66,0,0,0-2.19-.65,4.44,4.44,0,0,0-2.2.68c.53,3.91-1,7.52-4,8.81-3.85,1.62-8.66-1.08-10.75-6S120.81,58.67,124.66,57.05Z"
            />
         </clipPath>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
         <g id="Layer_1-2" data-name="Layer 1">
            {loader && (
               <circle
                  className="svg-color-5 logo-outline-loader"
                  cx="160.37"
                  cy="125.93"
                  r="165.93"
               />
            )}
            {loader && (
               <circle
                  className="svg-color-6"
                  cx="160.37"
                  cy="125.93"
                  r="165.93"
               />
            )}
            {background && (
               <circle
                  className="svg-color-background"
                  cx="160.37"
                  cy="125.93"
                  r="165.93"
               />
            )}
            <circle
               className="svg-color-2"
               cx="160.37"
               cy="125.93"
               r="125.93"
            />
            <polygon
               className="svg-color-2"
               points="78.87 218.61 278.63 218.61 278.63 110.85 78.87 41.23 78.87 218.61"
            />
            <polygon
               className="svg-color-2"
               points="261.98 68.38 286.71 73.42 286.6 87.89 302.19 91.85 300.19 104.28 313.19 110.63 302.52 127.06 313.38 139.3 296.82 147.01 298.18 159.74 283.45 163.25 276.16 186.92 261.98 68.38"
            />
            <path
               className="svg-color-2"
               d="M196.28,55.25l0-.12v-.07c-.05-.22-.13-.6-.26-1l0-.11,0-.11-.2-.62-.18-.58v0a13.55,13.55,0,0,0-.54-1.53c-.11-.25-.2-.49-.3-.74l-.1-.26-.08-.21-.09-.2c-.17-.37-.33-.69-.46-1l-.13-.27a13,13,0,0,0-.89-1.65l-.06-.11,0,0,0-.08-.33-.55-.22-.38-.26-.35-.07-.1c-.05-.07-.11-.14-.15-.21h0v0a29.16,29.16,0,0,0-10.6-9.07l-.66-.32-.15-.08-14.11-6.57h0a25.57,25.57,0,0,0-17-8.3c-.44,0-.88,0-1.31,0-6.4,0-11.42,3.67-14.9,7.48a10.53,10.53,0,0,0-.41-3.79,10.33,10.33,0,0,0-7.17-7.07h-.11c-.48-.15-.93-.27-1.38-.37a15,15,0,0,0-3.16-.33c-6,0-12.64,3.42-20.1,10.43a20.45,20.45,0,0,0-4-.39,20.1,20.1,0,0,0-13.1,5c-6,5-8.48,12.21-7.1,20.17a33.33,33.33,0,0,0,4.63,11.73l14.24-7.91a4.8,4.8,0,0,1,.48,3.09A11.82,11.82,0,0,1,98,55.34a27.11,27.11,0,0,1,2.85-3c2.29-2.06,8.44-4.1,15.31-5.1L118,47,119.58,46a46.1,46.1,0,0,0,5.16-4.2l-1.39,2.86,8.77,3,33.56,11.33,1,.35-.29,1.11,7.63,2.21a65.56,65.56,0,0,0,13.79,2.67l10.95.67ZM115,39.22c-4.72.68-14.64,2.66-19.59,7.1a36.4,36.4,0,0,0-3.69,3.82c-3,3.62-4.47,7.07-3.62,8.84-1.53-2.41-8-13.78.86-21.3a11.86,11.86,0,0,1,7.83-3.06A14.15,14.15,0,0,1,103,36.17c4.92-5.2,12.14-11.59,17.88-11.59a7,7,0,0,1,1.46.15c.23.05.44.11.64.17h0c1,.32,1.74.84,1.83,1.49C126.11,29.8,118.59,36.79,115,39.22Zm19.73.64S140.15,28.68,148,28.68l.65,0c16.09,1.29,19.66,22.48,19.66,22.48ZM177.2,55l-.41-2.42c.17-.9.24-1.79.34-2.7,0-.48,0-1,.05-1.43,0-.24,0-.48,0-.72l0-.71-.06-1.42c-.05-.47-.09-.94-.15-1.4l-.08-.71-.11-.69v0l.62.3a20.9,20.9,0,0,1,7.69,6.51l.37.51.32.56a11.35,11.35,0,0,1,.64,1.13c.19.4.4.79.59,1.21s.32.84.5,1.27a5.16,5.16,0,0,1,.23.66l.2.68.22.68c.07.23.11.47.16.71l0,.12A55.64,55.64,0,0,1,177.2,55Z"
            />
            <path
               className="svg-color-3"
               d="M148.63,28.71c-8.17-.66-13.9,11.15-13.9,11.15l33.56,11.33S164.72,30,148.63,28.71Z"
            />
            <path
               className="svg-color-4"
               d="M188.31,57c-.05-.24-.09-.48-.16-.71l-.22-.68-.2-.68a5.16,5.16,0,0,0-.23-.66c-.18-.43-.34-.85-.5-1.27s-.4-.81-.59-1.21a11.35,11.35,0,0,0-.64-1.13l-.32-.56-.37-.51a20.9,20.9,0,0,0-7.69-6.51l-.62-.3v0l.11.69.08.71c.06.46.1.93.15,1.4l.06,1.42,0,.71c0,.24,0,.48,0,.72,0,.48,0,.95-.05,1.43-.1,1-.17,1.91-.36,2.86-.12.68-.27,1.35-.45,2a58.37,58.37,0,0,0,12,2.36Z"
            />
            <path
               className="svg-color-5"
               d="M89,37.68C80.08,45.2,86.57,56.57,88.1,59c-.85-1.77.62-5.22,3.62-8.84,2.12-4,11.25-14,11.25-14C99.12,34.29,94,33.43,89,37.68Z"
            />
            <path
               className="svg-color-6"
               d="M122.31,24.73c-5.94-1.27-14,5.79-19.34,11.44,0,0-9.13,10-11.25,14a36.4,36.4,0,0,1,3.69-3.82c5-4.44,14.87-6.42,19.59-7.1C119.41,36.22,129.8,26.32,122.31,24.73Z"
            />
            <path
               className="svg-color-5"
               d="M95.41,46.32a23.15,23.15,0,0,1,5.25-3.57c2.31-2.7,4.26-4.84,4.26-4.84,5.35-5.65,13.41-12.7,19.35-11.44l.54,0c0-.84-1.08-1.47-2.5-1.77-5.94-1.27-14,5.79-19.34,11.44,0,0-9.13,10-11.25,14A36.4,36.4,0,0,1,95.41,46.32Z"
            />
            <path
               className="svg-color-7"
               d="M219.48,167.94l-1,24.63H105.67l1,13.05,162,.57-1.36-38.11Z"
            />
            <polygon
               className="svg-color-4"
               points="116.33 171.72 121.57 171.85 123.07 183.67 130.35 183.67 128.91 171.72 134.15 171.85 135.64 183.67 147.94 183.67 146.39 171.02 151.63 171.15 153.21 183.67 158.14 183.67 156.59 171.02 161.83 171.15 163.41 183.67 167.52 183.67 165.97 171.02 171.21 171.15 172.79 183.67 184.82 183.67 183.76 171.72 189.01 171.85 190.11 183.67 197.4 183.67 196.73 171.72 201.97 171.85 202.69 183.67 211.19 183.67 211.58 167.93 103.34 167.62 104.84 183.67 117.78 183.67 116.33 171.72"
            />
            <path
               className="svg-color-3"
               d="M208.13,110c-8,4.27-18.24,5.77-18.24,5.77s12,12.33,21.75,9.81a14.53,14.53,0,0,0,4.07-1.34l15-31.76a30.75,30.75,0,0,0-9.22,2.29S216.13,105.75,208.13,110Z"
            />
            <path
               className="svg-color-7"
               d="M245.92,87.81,222.6,137.1,247,155.2l24,1.1,12.23-45.45L278.79,100Z"
            />
            <path
               className="svg-color-2"
               d="M248.69,36.05v16.6s-.35,0-1,0c-5,0-27.74,1.34-33.62,25.13-3.8,15.35-18.55,22.4-35.68,22.4a67.64,67.64,0,0,1-9.54-.7A23.85,23.85,0,0,0,170,97a27.88,27.88,0,0,0,1.7-7.51,35.49,35.49,0,0,0-.19-7.51c-.18-1.22-.38-2.44-.68-3.65-.15-.6-.3-1.2-.48-1.81-.08-.3-.19-.61-.28-.91s-.2-.58-.36-1l-2.74-7.28-4.55,6.18a56.43,56.43,0,0,1-5.79,6.82l-.8.76-.4.38-.41.36-.82.71-.86.67-.42.34-.44.31-.89.62c-.6.38-1.21.78-1.84,1.11a21.51,21.51,0,0,1-8.25,2.64c-.71.07-1.42.11-2.14.11s-1.63,0-2.46-.13a22,22,0,0,1-4.73-1,15.12,15.12,0,0,0,4.11,3,19.68,19.68,0,0,0,5,1.74,21,21,0,0,0,4,.39c.46,0,.91,0,1.36,0a23.64,23.64,0,0,0,5.4-1,26.59,26.59,0,0,0,2.58-1l1.24-.58.62-.3.59-.33,1.19-.67,1.14-.74.57-.37.54-.39,1.08-.81c.53-.41,1-.83,1.54-1.26a32.46,32.46,0,0,1,.09,4.06,21.29,21.29,0,0,1-3.07,10.51l-.35.59-.42.56a11.36,11.36,0,0,1-.86,1.11c-.31.35-.61.72-.94,1.07l-1,1a29.38,29.38,0,0,1-4.88,3.58l-.67.41c-.23.13-.47.23-.7.36l-1.41.75c-1,.47-1.95.9-2.95,1.37l-3.07,1.24c-1.05.37-2.11.76-3.18,1.19a37,37,0,0,0,4.47.28,33.72,33.72,0,0,0,9.33-1.3l1.73-.52,1.68-.69c.29-.12.57-.23.85-.36l.83-.42.82-.44a7.39,7.39,0,0,0,.81-.47l1.5-1a105.77,105.77,0,0,0,15.23,4.18s1.11,9.6,23.21,23.66a187.16,187.16,0,0,1,30.5,24.19l-136.32-.38,4.44,50.66-52.45.32s-7.37-29.08-.23-46.3c6.8-16.39,25.49-19.78,39.75-19.78A95.27,95.27,0,0,1,103.71,146a210.72,210.72,0,0,1-9.15-27.8l-6.4,16.91c-7.33-1.24-17.27-5.4-17.27-5.4L69,118.72l-13.9,16.42L10.38,116.82S32.09,56.51,59,50a12.32,12.32,0,0,1,2.88-.34c11.22,0,22.36,14.95,28.63,25.1,1.26-8.7,4.33-16.49,10.18-22.13,5-4.84,11.15-6.71,17.86-6.71,22.57,0,51.81,21.12,68.6,21.12,4.12,0,7.5-1.28,9.84-4.45,14.7-19.92,22.77-26.56,51.7-26.56M140.5,62.66a7.09,7.09,0,0,0-5.1.42h0c-1.67-4-5.11-6.5-8.39-6.5a6,6,0,0,0-2.35.47c-3.85,1.62-5.28,7-3.2,11.9,1.68,4,5.11,6.5,8.39,6.5a6,6,0,0,0,2.36-.47c3-1.29,4.57-4.9,4-8.81a4.44,4.44,0,0,1,2.2-.68,3.66,3.66,0,0,1,2.19.65,12.34,12.34,0,0,0,.74,2.41c1.67,4,5.1,6.5,8.38,6.5a6,6,0,0,0,2.36-.47c3.85-1.62,5.28-7,3.19-11.9-1.67-4-5.1-6.5-8.38-6.5a6,6,0,0,0-2.36.47,7.2,7.2,0,0,0-4.07,6m-86.93,6.8A5,5,0,0,1,57,68.37c4.93,0,15.44,5,32.84,36.28l-.28-2.47A50.79,50.79,0,0,0,73,70.07c-5.18-4.62-9.1-6.14-12-6.14-5.56,0-7.46,5.53-7.46,5.53M248.69,27.84c-16,0-26.54,2.05-35.17,6.85s-15.05,12.1-23.13,23.05c-.31.42-.82,1.11-3.24,1.11-6.07,0-16.29-4.43-26.18-8.71-13.4-5.82-28.6-12.41-42.42-12.41-9.43,0-17.35,3-23.56,9a38.59,38.59,0,0,0-7.39,10c-1.24-1.45-2.48-2.81-3.72-4.06-7.36-7.41-14.76-11.17-22-11.17a21,21,0,0,0-4.81.57c-7.8,1.88-15.59,7.17-23.16,15.71A135.21,135.21,0,0,0,17.42,81.88,245.88,245.88,0,0,0,2.66,114L0,121.44l7.27,3L52,142.74l1.81.73a35.73,35.73,0,0,0-15.31,17.46C35,169.34,34,180.63,35.37,194.5a135.92,135.92,0,0,0,3,17.88L40,218.61l6.42,0,52.45-.31,8.9-.06-.78-8.86-3.65-41.72,127.34.36,20.17.05-14.41-14.12a195.87,195.87,0,0,0-31.83-25.25c-15.94-10.14-19.11-17.08-19.53-18.19l-.28-2.41a50.36,50.36,0,0,0,20.63-6.26A34.78,34.78,0,0,0,222,79.73c1.9-7.68,6-12.92,12.66-16a32.27,32.27,0,0,1,13-2.86h.52l13.6.65-.1-33.65Z"
            />
            <path
               className="svg-color-8"
               d="M92,158.22l138.66.38a275.17,275.17,0,0,0-30.5-23c-22.1-14.06-23.21-23.66-23.21-23.66a105.77,105.77,0,0,1-15.23-4.18l-1.5,1a7.39,7.39,0,0,1-.81.47l-.82.44-.83.42c-.28.13-.56.24-.85.36l-1.68.69-1.73.52a34.48,34.48,0,0,1-13.8,1c1.07-.43,2.13-.82,3.18-1.19l3.07-1.24c1-.47,2-.9,2.95-1.37l1.41-.75c.23-.13.47-.23.7-.36l.67-.41a29.38,29.38,0,0,0,4.88-3.58l1-1c.33-.35.63-.72.94-1.07a11.36,11.36,0,0,0,.86-1.11l.42-.56.35-.59a21.29,21.29,0,0,0,3.07-10.51,32.46,32.46,0,0,0-.09-4.06c-.5.43-1,.85-1.54,1.26l-1.08.81-.54.39-.57.37-1.14.74-1.19.67-.59.33-.62.3-1.24.58a26.59,26.59,0,0,1-2.58,1,23.64,23.64,0,0,1-5.4,1,21.22,21.22,0,0,1-5.41-.35,19.68,19.68,0,0,1-5-1.74,15.12,15.12,0,0,1-4.11-3,22,22,0,0,0,4.73,1,22.83,22.83,0,0,0,4.6,0,21.51,21.51,0,0,0,8.25-2.64c.63-.33,1.24-.73,1.84-1.11l.89-.62.44-.31.42-.34.86-.67.82-.71.41-.36.4-.38.8-.76a56.43,56.43,0,0,0,5.79-6.82l4.55-6.18,2.74,7.28c.16.43.25.69.36,1s.2.61.28.91c.18.61.33,1.21.48,1.81.3,1.21.5,2.43.68,3.65a35.49,35.49,0,0,1,.19,7.51A27.88,27.88,0,0,1,170,97a23.85,23.85,0,0,1-1.11,2.47c20.92,3,40.73-3.56,45.22-21.7,5-20.1,21.95-24.17,30.14-25,2.73-.26,9.35-.16,9.35-.16V36.05l-7.47,0c-26.84.4-34.86,7.23-49.11,26.54-14.71,19.93-70.21-35.1-96.3-10-5.85,5.64-8.92,13.43-10.18,22.13C83.7,63.76,71.16,47.08,59,50c-26.91,6.49-48.62,66.8-48.62,66.8l44.75,18.32L69,118.72l1.86,10.95s9.94,4.16,17.27,5.4l6.4-16.91a210.72,210.72,0,0,0,9.15,27.8s-46-9.8-57.62,18.11c-7.14,17.22.23,46.3.23,46.3l50.1-.32ZM124.66,57.05c3.85-1.62,8.66,1.08,10.74,6h0a7.09,7.09,0,0,1,5.1-.42,7.2,7.2,0,0,1,4.07-6c3.85-1.62,8.66,1.08,10.74,6S156,73,152.12,74.58s-8.66-1.08-10.74-6a12.34,12.34,0,0,1-.74-2.41,3.66,3.66,0,0,0-2.19-.65,4.44,4.44,0,0,0-2.2.68c.53,3.91-1,7.52-4,8.81-3.85,1.62-8.66-1.08-10.75-6S120.81,58.67,124.66,57.05ZM53.57,69.46S58,56.62,73,70.07a50.79,50.79,0,0,1,16.5,32.11l.28,2.47C64.25,58.69,53.57,69.46,53.57,69.46Z"
            />
            <path
               className="svg-color-4"
               d="M151.67,107.32a29.38,29.38,0,0,0,4.88-3.58l1-1c.33-.35.63-.72.94-1.07a11.36,11.36,0,0,0,.86-1.11l.42-.56.35-.59a21.29,21.29,0,0,0,3.07-10.51,32.46,32.46,0,0,0-.09-4.06c-.5.43-1,.85-1.54,1.26l-1.08.81-.54.39-.57.37-1.14.74-1.19.67-.59.33-.62.3-1.24.58a26.59,26.59,0,0,1-2.58,1,23.64,23.64,0,0,1-5.4,1,21.22,21.22,0,0,1-5.41-.35c-.49-.1-1-.22-1.43-.35h0s-1.79,7.2.45,12.06a16.09,16.09,0,0,0,5.68,6.59c.24-.13,3.32-1.45,5.06-2.48Z"
            />
            <path
               className="svg-color-1"
               d="M73,70.07C58,56.62,53.57,69.46,53.57,69.46s10.68-10.77,36.25,35.19l-.28-2.47A50.79,50.79,0,0,0,73,70.07Z"
            />
            <path
               className="svg-color-1"
               d="M144.57,56.65a7.2,7.2,0,0,0-4.07,6,7.09,7.09,0,0,0-5.1.42h0c-2.08-4.95-6.89-7.65-10.74-6s-5.28,7-3.2,11.9,6.9,7.65,10.75,6c3-1.29,4.57-4.9,4-8.81a4.44,4.44,0,0,1,2.2-.68,3.66,3.66,0,0,1,2.19.65,12.34,12.34,0,0,0,.74,2.41c2.08,5,6.89,7.65,10.74,6s5.28-7,3.19-11.9S148.42,55,144.57,56.65Z"
            />
            <ellipse
               className="svg-color-9"
               cx="247.15"
               cy="128.99"
               rx="13.06"
               ry="13.82"
            />
            <ellipse
               className="svg-color-7"
               cx="248.69"
               cy="129.91"
               rx="4.23"
               ry="4.48"
            />
            <ellipse
               className="svg-color-9"
               cx="257.34"
               cy="105.82"
               rx="6.15"
               ry="6.51"
            />
            <ellipse
               className="svg-color-7"
               cx="257.68"
               cy="105.99"
               rx="1.68"
               ry="1.78"
            />
            <polygon
               className="svg-color-3"
               points="106.63 209.13 106.25 200.45 260.76 200.81 260.44 168.08 267.23 168.08 268.59 209.71 106.63 209.13"
            />
            <polygon
               className="svg-color-3"
               points="260.15 155.8 278.79 100.02 283.26 110.85 271.03 156.3 260.15 155.8"
            />
            <g className="svg-isolate">
               <g className="svg-round-clip-1">
                  <polyline
                     className="svg-color-9"
                     points="233.59 170.49 224.73 170.49 224.59 176.26 233.54 176.26 233.59 170.49"
                  />
                  <polyline
                     className="svg-color-9"
                     points="243.7 170.49 234.83 170.49 234.79 176.26 243.74 176.26 243.7 170.49"
                  />
                  <polyline
                     className="svg-color-6"
                     points="253.8 170.49 244.94 170.49 244.99 176.26 253.94 176.26 253.8 170.49"
                  />
                  <polyline
                     className="svg-color-9"
                     points="233.52 177.75 224.55 177.75 224.4 183.66 233.47 183.66 233.52 177.75"
                  />
                  <polyline
                     className="svg-color-9"
                     points="243.75 177.75 234.78 177.75 234.73 183.66 243.79 183.66 243.75 177.75"
                  />
                  <polyline
                     className="svg-color-9"
                     points="253.98 177.75 245 177.75 245.06 183.66 254.12 183.66 253.98 177.75"
                  />
                  <polyline
                     className="svg-color-9"
                     points="233.45 185.19 224.37 185.19 224.22 191.26 233.39 191.26 233.45 185.19"
                  />
                  <polyline
                     className="svg-color-6"
                     points="243.81 185.19 234.72 185.19 234.68 191.26 243.85 191.26 243.81 185.19"
                  />
                  <polyline
                     className="svg-color-9"
                     points="254.16 185.19 245.08 185.19 245.13 191.26 254.31 191.26 254.16 185.19"
                  />
               </g>
            </g>
            <path
               className="svg-color-3"
               d="M157.46,118.82c7.87-1.47,8.26-3.72,8.26-3.72a19.44,19.44,0,0,0,6.5,1.06c4.57.14,5.95-1,5.95-1h0a10.45,10.45,0,0,1-1.23-3.25,105.77,105.77,0,0,1-15.23-4.18l-1.5,1a7.39,7.39,0,0,1-.81.47l-.82.44-.83.42c-.28.13-.56.24-.85.36l-1.68.69-1.73.52a33.72,33.72,0,0,1-9.33,1.3,37,37,0,0,1-4.47-.28h0S149.58,120.28,157.46,118.82Z"
            />
            <polygon
               className="svg-color-3"
               points="91.98 158.22 91.55 153.41 222.6 151.67 230.65 158.6 91.98 158.22"
            />
            <path
               className="svg-color-4"
               d="M44.58,201.59s.92-6.57,7-6.94c6.37-.38,8.89,6.16,8.89,6.16s.49-5.52,7.88-5.49,9.07,14.85,9.07,14.85l-31.12.2Z"
            />
            <path
               className="svg-color-3"
               d="M53.57,69.46s16.52,11.88,24.15,39.75,12.1-4.56,12.1-4.56S68.42,61,53.57,69.46Z"
            />
            <path
               className="svg-color-1"
               d="M144.57,56.65a7.2,7.2,0,0,0-4.07,6,7.09,7.09,0,0,0-5.1.42h0c-2.08-4.95-6.89-7.65-10.74-6s-5.28,7-3.2,11.9,6.9,7.65,10.75,6c3-1.29,4.57-4.9,4-8.81a4.44,4.44,0,0,1,2.2-.68,3.66,3.66,0,0,1,2.19.65,12.34,12.34,0,0,0,.74,2.41c2.08,5,6.89,7.65,10.74,6s5.28-7,3.19-11.9S148.42,55,144.57,56.65Z"
            />
            <g className="svg-round-clip-2">
               <polygon
                  className="svg-color-2"
                  points="140.5 62.66 140.64 66.14 138.82 66.5 137.08 61.36 140.5 62.66"
               />
            </g>
            <path
               className="svg-color-7"
               d="M160.35,241a109.28,109.28,0,0,0,55.08-14.48H103.85A117.6,117.6,0,0,0,160.35,241Z"
            />
            <path
               className="svg-color-9"
               d="M91.72,218.61a81.88,81.88,0,0,0,12.13,7.93H215.43a71.64,71.64,0,0,0,11.35-7.93Z"
            />
         </g>
      </g>
   </svg>
);

export { RoundLogo };
